import { useLocation } from "react-router-dom";
import AppShell from "./layout/AppShell";
import DashboardPage from "./pages/dashboard/DashboardPage";

const V2App = () => {
  const location = useLocation();
  const activeNavId = location.pathname.includes("/dashboard")
    ? "dashboard"
    : undefined;

  return (
    <AppShell activeNavId={activeNavId}>
      <DashboardPage />
    </AppShell>
  );
};

export default V2App;
